import { render, staticRenderFns } from "./CriterioPuntajePage.vue?vue&type=template&id=4bc2c4a8"
import script from "./CriterioPuntajePage.js?vue&type=script&lang=js&external"
export * from "./CriterioPuntajePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports